var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovistarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "150px",
    height: "29px",
    viewBox: "0 0 151 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 31.695312 -0.0234375 C 32.15625 -0.0234375 32.613281 -0.0234375 33.074219 -0.0234375 C 34.566406 0.242188 35.734375 1.003906 36.585938 2.265625 C 37.351562 3.425781 37.925781 4.675781 38.308594 6.019531 C 39.265625 9.289062 39.679688 12.625 39.558594 16.03125 C 39.507812 17.628906 39.320312 19.210938 39 20.777344 C 38.894531 21.464844 38.636719 22.085938 38.222656 22.632812 C 37.511719 23.398438 36.65625 23.636719 35.660156 23.347656 C 34.957031 22.96875 34.535156 22.386719 34.390625 21.597656 C 34.347656 21.246094 34.328125 20.894531 34.324219 20.542969 C 34.464844 18.953125 34.585938 17.363281 34.691406 15.773438 C 34.730469 14.851562 34.714844 13.929688 34.648438 13.011719 C 34.59375 12.179688 34.242188 11.507812 33.589844 11.003906 C 32.882812 10.621094 32.175781 10.636719 31.480469 11.046875 C 31.335938 11.148438 31.191406 11.25 31.050781 11.351562 C 30.078125 12.277344 29.324219 13.363281 28.785156 14.609375 C 27.683594 17.316406 26.738281 20.078125 25.941406 22.894531 C 24.6875 26.308594 22.230469 27.992188 18.574219 27.941406 C 15.855469 27.835938 13.773438 26.640625 12.324219 24.359375 C 10.839844 21.785156 9.328125 19.226562 7.800781 16.679688 C 7.488281 16.222656 7.09375 15.855469 6.613281 15.578125 C 5.601562 15.394531 4.960938 15.804688 4.695312 16.808594 C 4.570312 17.484375 4.585938 18.160156 4.742188 18.835938 C 5.097656 20.839844 5.628906 22.796875 6.335938 24.707031 C 6.503906 25.332031 6.648438 25.964844 6.765625 26.605469 C 6.90625 27.402344 6.699219 28.085938 6.140625 28.65625 C 5.945312 28.808594 5.730469 28.917969 5.496094 28.976562 C 5.191406 28.976562 4.890625 28.976562 4.589844 28.976562 C 3.71875 28.746094 3.066406 28.230469 2.628906 27.425781 C 1.226562 24.144531 0.34375 20.734375 -0.0234375 17.195312 C -0.0234375 16.261719 -0.0234375 15.328125 -0.0234375 14.390625 C 0.136719 12 0.691406 9.699219 1.636719 7.488281 C 2.148438 6.34375 2.859375 5.34375 3.769531 4.488281 C 5.492188 3.050781 7.414062 2.691406 9.546875 3.410156 C 10.53125 3.835938 11.285156 4.519531 11.808594 5.460938 C 12.546875 6.300781 13.234375 7.175781 13.875 8.089844 C 14.703125 9.371094 15.507812 10.667969 16.289062 11.976562 C 16.90625 12.851562 17.703125 13.507812 18.679688 13.9375 C 20.492188 14.394531 21.894531 13.824219 22.882812 12.234375 C 23.78125 9.960938 24.714844 7.703125 25.683594 5.460938 C 26.261719 3.945312 27.144531 2.644531 28.335938 1.554688 C 29.308594 0.714844 30.429688 0.1875 31.695312 -0.0234375 Z M 31.695312 -0.0234375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,65.882353%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 121.285156 5.632812 C 122.132812 5.625 122.980469 5.632812 123.828125 5.652344 C 123.90625 5.695312 123.957031 5.761719 123.980469 5.847656 C 124 6.738281 124.007812 7.632812 124 8.523438 C 124.9375 8.515625 125.871094 8.523438 126.804688 8.542969 C 126.882812 8.566406 126.933594 8.617188 126.953125 8.695312 C 126.984375 9.488281 126.984375 10.277344 126.953125 11.070312 C 126.921875 11.097656 126.886719 11.117188 126.847656 11.132812 C 125.902344 11.199219 124.953125 11.21875 124 11.199219 C 123.996094 13.527344 124 15.859375 124.023438 18.191406 C 124.101562 18.707031 124.289062 19.183594 124.582031 19.613281 C 125.039062 19.988281 125.5625 20.191406 126.15625 20.21875 C 126.441406 20.175781 126.730469 20.171875 127.019531 20.195312 C 127.054688 20.230469 127.089844 20.269531 127.125 20.304688 C 127.195312 21.09375 127.210938 21.882812 127.167969 22.679688 C 125.363281 23.066406 123.71875 22.699219 122.234375 21.578125 C 121.640625 20.9375 121.273438 20.183594 121.136719 19.3125 C 121.074219 18.925781 121.03125 18.539062 121.007812 18.148438 C 120.976562 14.03125 120.976562 9.917969 121.007812 5.804688 C 121.085938 5.710938 121.175781 5.65625 121.285156 5.632812 Z M 121.285156 5.632812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 78.839844 8.132812 C 79.839844 8.121094 80.832031 8.214844 81.8125 8.414062 C 83.539062 8.835938 84.667969 9.890625 85.195312 11.585938 C 85.855469 14.25 85.855469 16.910156 85.195312 19.570312 C 84.574219 21.496094 83.261719 22.597656 81.253906 22.871094 C 80.0625 23.03125 78.871094 23.0625 77.675781 22.957031 C 74.65625 22.695312 73.011719 21.046875 72.742188 18.015625 C 72.417969 15.882812 72.519531 13.769531 73.042969 11.671875 C 73.628906 9.78125 74.898438 8.664062 76.859375 8.328125 C 77.519531 8.21875 78.179688 8.152344 78.839844 8.132812 Z M 78.324219 10.808594 C 78.898438 10.804688 79.472656 10.808594 80.046875 10.832031 C 81.203125 10.875 81.957031 11.441406 82.308594 12.535156 C 82.503906 13.535156 82.597656 14.542969 82.589844 15.558594 C 82.542969 16.464844 82.480469 17.371094 82.394531 18.277344 C 82.179688 19.527344 81.441406 20.210938 80.175781 20.324219 C 79.292969 20.433594 78.414062 20.390625 77.546875 20.195312 C 76.777344 19.957031 76.28125 19.445312 76.058594 18.664062 C 75.863281 17.742188 75.769531 16.804688 75.78125 15.859375 C 75.8125 15.066406 75.847656 14.277344 75.886719 13.484375 C 75.914062 12.863281 76.085938 12.289062 76.40625 11.757812 C 76.648438 11.441406 76.960938 11.203125 77.332031 11.046875 C 77.660156 10.9375 77.992188 10.859375 78.324219 10.808594 Z M 78.324219 10.808594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 134.773438 8.222656 C 136.382812 8.140625 137.875 8.507812 139.257812 9.320312 C 140.253906 10.085938 140.820312 11.101562 140.960938 12.363281 C 141.007812 13.421875 141.027344 14.476562 141.023438 15.535156 C 141.027344 16.636719 141.007812 17.738281 140.960938 18.835938 C 140.890625 20.664062 140.007812 21.894531 138.308594 22.527344 C 137.601562 22.796875 136.867188 22.953125 136.109375 23 C 134.832031 23.089844 133.566406 22.988281 132.320312 22.699219 C 130.519531 22.234375 129.449219 21.089844 129.109375 19.269531 C 128.789062 17.617188 129.210938 16.203125 130.378906 15.019531 C 131.316406 14.332031 132.367188 13.914062 133.527344 13.765625 C 135.027344 13.683594 136.523438 13.761719 138.007812 14.003906 C 138.019531 13.386719 137.941406 12.78125 137.769531 12.191406 C 137.625 11.785156 137.359375 11.492188 136.972656 11.304688 C 136.261719 11.027344 135.519531 10.878906 134.753906 10.851562 C 133.484375 10.859375 132.230469 10.972656 130.984375 11.199219 C 130.835938 11.1875 130.714844 11.128906 130.617188 11.027344 C 130.585938 10.308594 130.585938 9.585938 130.617188 8.867188 C 130.640625 8.804688 130.679688 8.746094 130.722656 8.695312 C 131.246094 8.539062 131.777344 8.433594 132.320312 8.371094 C 133.144531 8.296875 133.960938 8.246094 134.773438 8.222656 Z M 134.472656 16.246094 C 135.691406 16.234375 136.898438 16.335938 138.09375 16.550781 C 138.0625 17.371094 138.011719 18.191406 137.941406 19.007812 C 137.902344 19.453125 137.695312 19.792969 137.316406 20.023438 C 136.972656 20.238281 136.597656 20.382812 136.199219 20.457031 C 135.664062 20.484375 135.132812 20.484375 134.601562 20.457031 C 133.796875 20.4375 133.113281 20.140625 132.554688 19.570312 C 132.171875 18.964844 132.085938 18.320312 132.296875 17.628906 C 132.535156 17.066406 132.945312 16.683594 133.527344 16.484375 C 133.839844 16.378906 134.15625 16.296875 134.472656 16.246094 Z M 134.472656 16.246094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 53.628906 8.265625 C 54.421875 8.257812 55.210938 8.265625 56 8.285156 C 56.941406 8.34375 57.832031 8.585938 58.671875 9.019531 C 58.960938 9.1875 59.21875 9.394531 59.449219 9.644531 C 60.050781 9.027344 60.785156 8.628906 61.644531 8.457031 C 62.027344 8.371094 62.417969 8.316406 62.808594 8.285156 C 63.640625 8.257812 64.476562 8.257812 65.308594 8.285156 C 66.550781 8.339844 67.671875 8.730469 68.667969 9.449219 C 69.242188 10 69.609375 10.671875 69.769531 11.457031 C 69.855469 11.796875 69.910156 12.144531 69.941406 12.492188 C 69.941406 15.832031 69.914062 19.171875 69.855469 22.503906 C 69.820312 22.542969 69.78125 22.578125 69.746094 22.613281 C 68.855469 22.640625 67.964844 22.640625 67.074219 22.613281 C 67 22.570312 66.949219 22.503906 66.925781 22.417969 C 66.910156 19.414062 66.894531 16.40625 66.882812 13.398438 C 66.863281 13.007812 66.820312 12.621094 66.753906 12.234375 C 66.617188 11.738281 66.320312 11.371094 65.867188 11.132812 C 65.253906 10.875 64.617188 10.765625 63.949219 10.808594 C 63.199219 10.753906 62.488281 10.890625 61.816406 11.21875 C 61.4375 11.457031 61.183594 11.796875 61.0625 12.234375 C 60.992188 12.605469 60.949219 12.980469 60.933594 13.355469 C 60.921875 16.390625 60.90625 19.425781 60.890625 22.460938 C 60.875 22.5625 60.828125 22.640625 60.742188 22.699219 C 59.835938 22.726562 58.929688 22.726562 58.027344 22.699219 C 58.003906 22.679688 57.984375 22.65625 57.960938 22.632812 C 57.902344 19.804688 57.875 16.96875 57.875 14.132812 C 58.09375 11.886719 57.082031 10.808594 54.835938 10.898438 C 54.027344 10.839844 53.28125 11.019531 52.597656 11.4375 C 52.347656 11.65625 52.167969 11.921875 52.058594 12.234375 C 51.953125 12.789062 51.894531 13.351562 51.882812 13.917969 C 51.871094 16.808594 51.855469 19.699219 51.839844 22.589844 C 51.804688 22.644531 51.753906 22.679688 51.691406 22.699219 C 50.785156 22.726562 49.878906 22.726562 48.976562 22.699219 C 48.933594 22.636719 48.898438 22.574219 48.867188 22.503906 C 48.839844 19.140625 48.839844 15.773438 48.867188 12.40625 C 49.167969 10.25 50.382812 8.933594 52.507812 8.457031 C 52.886719 8.382812 53.261719 8.316406 53.628906 8.265625 Z M 53.628906 8.265625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 150.976562 8.351562 C 150.976562 9.15625 150.976562 9.960938 150.976562 10.765625 C 150.925781 10.808594 150.871094 10.847656 150.804688 10.875 C 150.117188 10.890625 149.425781 10.902344 148.738281 10.917969 C 148.183594 10.945312 147.679688 11.117188 147.230469 11.4375 C 146.910156 11.75 146.730469 12.128906 146.691406 12.578125 C 146.648438 12.9375 146.621094 13.296875 146.605469 13.660156 C 146.589844 16.664062 146.574219 19.671875 146.5625 22.679688 C 146.523438 22.730469 146.472656 22.765625 146.410156 22.785156 C 145.503906 22.816406 144.601562 22.816406 143.695312 22.785156 C 143.644531 22.746094 143.609375 22.695312 143.589844 22.632812 C 143.578125 19.449219 143.558594 16.261719 143.523438 13.074219 C 143.632812 10.289062 145.070312 8.707031 147.832031 8.328125 C 148.851562 8.261719 149.871094 8.246094 150.890625 8.285156 C 150.914062 8.316406 150.945312 8.339844 150.976562 8.351562 Z M 150.976562 8.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 87.414062 8.4375 C 88.378906 8.429688 89.339844 8.4375 90.300781 8.457031 C 90.363281 8.476562 90.414062 8.515625 90.453125 8.566406 C 90.648438 11.503906 91.296875 14.335938 92.394531 17.066406 C 92.734375 17.960938 93.117188 18.839844 93.535156 19.699219 C 94.753906 17.195312 95.652344 14.578125 96.226562 11.847656 C 96.410156 10.753906 96.554688 9.664062 96.660156 8.566406 C 96.699219 8.515625 96.75 8.476562 96.808594 8.457031 C 97.757812 8.429688 98.707031 8.429688 99.652344 8.457031 C 99.675781 8.480469 99.695312 8.5 99.71875 8.523438 C 99.789062 8.820312 99.800781 9.121094 99.761719 9.429688 C 99.496094 11.957031 98.894531 14.402344 97.953125 16.765625 C 97.164062 18.773438 96.257812 20.730469 95.238281 22.632812 C 95.1875 22.683594 95.136719 22.734375 95.085938 22.785156 C 94.082031 22.816406 93.074219 22.816406 92.070312 22.785156 C 91.953125 22.730469 91.859375 22.652344 91.789062 22.546875 C 90.460938 20.160156 89.355469 17.671875 88.472656 15.082031 C 87.777344 12.949219 87.390625 10.761719 87.308594 8.523438 C 87.351562 8.5 87.386719 8.46875 87.414062 8.4375 Z M 87.414062 8.4375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 112.582031 8.4375 C 114.148438 8.386719 115.699219 8.507812 117.234375 8.804688 C 117.410156 8.824219 117.546875 8.902344 117.644531 9.039062 C 117.675781 9.773438 117.675781 10.507812 117.644531 11.242188 C 117.625 11.292969 117.589844 11.328125 117.539062 11.351562 C 117.410156 11.378906 117.277344 11.378906 117.148438 11.351562 C 115.714844 11.023438 114.261719 10.921875 112.796875 11.046875 C 112.230469 11.089844 111.746094 11.316406 111.355469 11.714844 C 111.113281 12.136719 111.097656 12.570312 111.3125 13.011719 C 111.652344 13.34375 112.046875 13.597656 112.496094 13.765625 C 113.425781 14.089844 114.359375 14.40625 115.296875 14.714844 C 116.25 15.066406 117.089844 15.59375 117.816406 16.289062 C 118.550781 17.300781 118.796875 18.421875 118.550781 19.65625 C 118.273438 20.9375 117.550781 21.867188 116.375 22.441406 C 115.226562 22.925781 114.027344 23.148438 112.777344 23.109375 C 111.375 23.109375 110.003906 22.917969 108.660156 22.527344 C 108.554688 22.476562 108.472656 22.398438 108.421875 22.289062 C 108.394531 21.527344 108.394531 20.765625 108.421875 20.003906 C 108.441406 19.960938 108.460938 19.925781 108.488281 19.894531 C 108.601562 19.867188 108.71875 19.867188 108.832031 19.894531 C 110.496094 20.421875 112.191406 20.582031 113.917969 20.367188 C 114.433594 20.285156 114.890625 20.082031 115.296875 19.765625 C 116.003906 18.707031 115.773438 17.914062 114.609375 17.390625 C 113.390625 16.972656 112.183594 16.523438 110.988281 16.054688 C 110.382812 15.800781 109.792969 15.511719 109.222656 15.191406 C 108.574219 14.570312 108.226562 13.804688 108.1875 12.902344 C 108.144531 10.632812 109.222656 9.222656 111.417969 8.675781 C 111.808594 8.574219 112.195312 8.496094 112.582031 8.4375 Z M 112.582031 8.4375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151,
    height: 29
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,66.27451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 102.585938 8.523438 C 103.460938 8.515625 104.335938 8.523438 105.214844 8.542969 C 105.292969 8.566406 105.34375 8.617188 105.363281 8.695312 C 105.394531 13.355469 105.394531 18.015625 105.363281 22.679688 C 105.324219 22.730469 105.273438 22.765625 105.214844 22.785156 C 104.292969 22.820312 103.375 22.816406 102.453125 22.765625 C 102.441406 22.730469 102.421875 22.699219 102.390625 22.679688 C 102.363281 18.003906 102.363281 13.328125 102.390625 8.652344 C 102.460938 8.613281 102.527344 8.570312 102.585938 8.523438 Z M 102.585938 8.523438 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovistarLogo);
export default __webpack_public_path__ + "static/media/Movistar-logo.3033d2cc712dbced930a6c15675f2c30.svg";
export { ForwardRef as ReactComponent };